import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { selectShadow } from 'components/shadow_grid/shadows/store/shadows/actions';

import Actions from './actions';
import DocumentUsage from './document_usage';
import { formatDateTime } from 'helpers/formatters/date_time_formats';

export function ShadowRow({ selectShadow, selectGlobalShadow, shadow }) {

  function setSelectedShadow() {
    selectShadow(shadow);
    if (selectGlobalShadow) {
      selectGlobalShadow(shadow);
    }
  }

  return (
    <tr>
      <td>
        <div className="shadow-details">
          <a className="clickable" name="clickable-shadow" onClick={setSelectedShadow}>
            {shadow.name}
          </a>

          <span className="updated-at">
            Last edited {formatDateTime(shadow.updatedAt)}
          </span>
        </div>
      </td>

      <td>
        {shadow.gridName}
      </td>

      <td>
        {shadow.gridVersionName}
      </td>

      <td>
        <DocumentUsage shadow={shadow} />
      </td>

      <td>
        <Actions shadow={shadow} />
      </td>
    </tr>
  );
}

ShadowRow.propTypes = {
  selectGlobalShadow: PropTypes.func,
  selectShadow: PropTypes.func.isRequired,
  shadow: PropTypes.shape({
    gridName: PropTypes.string.isRequired,
    gridVersionName: PropTypes.string,
    name: PropTypes.string.isRequired,
  }),
};

const mapDispatchToProps = {
  selectShadow,
};

export default connect(null, mapDispatchToProps)(ShadowRow);
